import * as actions from '../../actions';

const suggestionsQuery = (state = '', action) => {
    switch (action.type) {
        case actions.SET_SUGGESTIONS:
            return action.payload.query ?? state;
        default:
            return state;
    }
};

export default suggestionsQuery;
